import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import Faq from "./Component/Faq";
import Cookies from "./Component/Cookies";
import PolicyIndex from "./Component/PolicyIndex";
import {
  AcceptableUsePolicy,
  AccessibilityPolicy,
  ComplaintsPolicy,
  DataChoicesPolicy,
  IntellectualPropertyPolicy,
  OrderPolicy,
  PaymentPolicy,
  PricingPolicy,
  ProductSafetyPolicy,
  PromotionsPolicy,
  SiteNoticePolicy,
  WarrantyPolicy,
} from "./Component/AdditionalPolicies";

function App() {
  return (
    <CartProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/policies" element={<PolicyIndex />} />
          <Route path="/data-choices" element={<DataChoicesPolicy />} />
          <Route path="/orders" element={<OrderPolicy />} />
          <Route path="/payments" element={<PaymentPolicy />} />
          <Route path="/pricing" element={<PricingPolicy />} />
          <Route path="/warranty" element={<WarrantyPolicy />} />
          <Route path="/product-safety" element={<ProductSafetyPolicy />} />
          <Route path="/promotions" element={<PromotionsPolicy />} />
          <Route path="/acceptable-use" element={<AcceptableUsePolicy />} />
          <Route path="/intellectual-property" element={<IntellectualPropertyPolicy />} />
          <Route path="/accessibility" element={<AccessibilityPolicy />} />
          <Route path="/complaints" element={<ComplaintsPolicy />} />
          <Route path="/site-notice" element={<SiteNoticePolicy />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/payment" element={<PaySuccess />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
